import { useEffect, useState } from "react";

import { Container, Button, Card, CardContent } from "@material-ui/core";
import { Add } from "@mui/icons-material";
import Api from "lib/api/httpRequestHelper";

import DialogCreateEdit from "./components/dialog-create-edit";
import TableCategoria from "./components/table-categoria";
import HeaderClientes from "components/_refactor/headers/clients";
import LoadingData from "components/Loading/LoadingData";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";

export default function CategoriasManuais() {
  const snackbar = useSnackbar();

  const [categorias, setCategorias] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCategoria, setSelectedCategoria] = useState(null);
  const [typeForm, setTypeForm] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchCategorias = async () => {
    setLoading(true);
    try {
      const response = await Api.get("categoria-list", "conteudo", "", true);
      setCategorias(response?.Result?.Categorias || []);
    } catch (error) {
      snackbar.showMessage(error?.toString() || "Erro ao buscar categorias", {
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleOpenCreate = () => {
    setSelectedCategoria(null);
    setTypeForm("create");
    setOpenDialog(true);
  };

  const handleOpenEdit = (categoria) => {
    setSelectedCategoria(categoria);
    setTypeForm("edit");
    setOpenDialog(true);
  };

  const handleOpenDelete = (categoria) => {
    setSelectedCategoria(categoria);
    setTypeForm("remove");
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedCategoria(null);
    setTypeForm(null);
  };

  const handleRefresh = () => {
    fetchCategorias();
  };

  useEffect(() => {
    fetchCategorias();
  }, []);

  return (
    <>
      <HeaderClientes section="Categorias de Manuais" subsection="Conteúdo" />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        {categorias.length === 0 && (
          <Card>
            <CardContent
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button variant="contained" onClick={handleOpenCreate}>
                <Add />
                Nova Categoria
              </Button>
            </CardContent>
          </Card>
        )}

        {loading && (
          <Card>
            <CardContent>
              <LoadingData
                searching={loading}
                onClick={() => setLoading(false)}
                label="Buscando categorias..."
              />
            </CardContent>
          </Card>
        )}

        {!loading && (
          <TableCategoria
            data={categorias}
            onEdit={handleOpenEdit}
            onDelete={handleOpenDelete}
            onCreate={handleOpenCreate}
            loading={loading}
          />
        )}
      </Container>

      {openDialog && (
        <DialogCreateEdit
          open={openDialog}
          onClose={handleCloseDialog}
          selectedRow={selectedCategoria}
          typeForm={typeForm}
          refresh={handleRefresh}
        />
      )}
    </>
  );
}
